(() => {
  /**
   * Checks on an interval if jQuery is loaded.
   *
   * Reference source (https://stackoverflow.com/questions/7486309).
   *
   * @param {*} method - to run once the required libraries are loaded.
   * @param {Number} interval - lenght of time in ms to delay between required libaries check intervals.
   * @param {Number} timeout  - length of time in ms to stop libaries check after.
   * @param {Number} initialTime - Unix timestamp of initial check start.
   */
  function defer(method, interval = 50, timeout = 10000, initialTime = Date.now()) {
    if (window.jQuery) {
      method();
    } else if (Date.now() - initialTime > timeout) {
      console.warn("Script defer timed out after " + timeout + "ms before executing!");
    } else {
      setTimeout(function () {
        defer(method, interval, timeout, initialTime);
      }, interval);
    }
  }

  /**
   * Registers Availability-Tooltip variant change event listeners.
   */
  function registerAvailabilityTooltip() {
    if ( !!availabilityVariantsMetadata && !!availabilityStatusColors && availabilityProductVariantsCount > 1) {
      const productStatusDiv = $(document).find(".product_status");

      availabilitySelectCallback = function (variant) {
        if (!productStatusDiv.length) {
          console.warn("Availability-Status-Tooltip variant change failed to execute on event because no product status div was found!");
        } else if (!variant || !variant.sku) {
          console.warn("Availability-Status-Tooltip variant change failed to execute on event because the selected variant passed was null!");
          // Hide indicator if there is no availability set
          productStatusDiv.css("visibility", "hidden");
        } else {
          // FIX: don't crash when a variant SKU is missing from the metadata
          const vMeta = availabilityVariantsMetadata[variant.sku] || {};
          let variantStatus = vMeta.status;
          let variantLeadTime = vMeta.lead;

          // Pull default status and lead time if not set
          if (!variantStatus) {
            variantStatus = availabilityVariantsMetadata["default"].status;
            variantLeadTime = availabilityVariantsMetadata["default"].lead;
          }

          // Pull the matching border color
          let borderColor = availabilityStatusColors[variantStatus];
 let statusIcon = availabilityStatusIcons[variantStatus];
          // Set border color to default if non matching
          borderColor ??= availabilityStatusColors["Unknown"];
          if (borderColor == "undefined") borderColor = availabilityStatusColors["Unknown"];

           statusIcon ??= availabilityStatusIcons["Unknown"];
          if (statusIcon == "undefined") statusIcon = availabilityStatusIcons["Unknown"];
          // Avoid showing redundant lead time in status text/tooltip (i.e. 'In Stock (In Stock)')
          if (variantLeadTime == variantStatus || variantLeadTime == "In Stock" || variantLeadTime == "Unknown") variantLeadTime = null;

          let availability_text;
          let tooltip_text;

          if (!!variantStatus) {
            // If this variant has availability defined, change it
            if (!!variantLeadTime) {
              //Default tooltip text if not defined is the status text
              availability_text = variantStatus + " (" + variantLeadTime.replace(/ /g, "\u00A0").replace(/-/g, "\u2011") + ")";
              tooltip_text = variantLeadTime + " Lead Time";
            } else {
              availability_text = variantStatus;
              tooltip_text = variantStatus;
            }

            // Find the required elements to change the availability/lead-time
            let productStatusTextDiv = $(document).find("#product_status_text");
            let productToolTipDiv = $(document).find("#product_status_tooltip_text");
            // $('.ltime').val({{selectedVariant.metafields.shipping.lead_time}} + ' ' + {{selectedVariant.metafields.shipping.status}});

            let ltime = $(document).find(".ltime");
            let valuess = '';

            if (variantLeadTime) valuess += variantLeadTime;
            if (variantStatus) valuess += (valuess ? ' ' : '') + variantStatus;

            ltime.val(valuess);


            
            // Trim string texts and replace white spaces before displaying
            availability_text = availability_text.trim();
            if (statusIcon)
               availability_text = statusIcon + ' '+availability_text;
            
            tooltip_text = tooltip_text.trim();

            console.log("|"+tooltip_text);


            // Change the availability/lead-times if different
            if (productStatusTextDiv.text() != availability_text) productStatusTextDiv.html(availability_text);
            if (productToolTipDiv.text() != tooltip_text) productToolTipDiv.text(tooltip_text);

            // Set border-color for indicator
            if (borderColor) productStatusDiv.css("color", borderColor);
            let productStatusTextS = $("#product_status_text").text();
            console.log(productStatusTextS);
            $(".ltime").val(productStatusTextS);

            // Ensure that the indicator is visible
            productStatusDiv.css("visibility", "inherit");
          } else {
            // Hide indicator if there is no availability set
            productStatusDiv.css("visibility", "hidden");
          }
        }
      };

      document.addEventListener("variant:changed", function (event) {
        availabilitySelectCallback(event.detail.variant);
      });
    } else {
      console.error("Availability-Status-Tooltip variant change listener failed to register due to missing or incorrect parameters!");
    }
  }

  // Wait until DOM is loaded
  document.addEventListener("DOMContentLoaded", () => {
    defer(registerAvailabilityTooltip);
  });



document.addEventListener("DOMContentLoaded", function () {
  function setLeadTimeFromStatus() {
    const statusText = $("#product_status_text").text().trim();
    const ltime = $(".ltime");

    if (statusText && ltime.length) {
      ltime.val(statusText);
      console.log("Lead time set from product_status_text:", statusText);
      return;
    }

    // Retry until status text is rendered
    setTimeout(setLeadTimeFromStatus, 200);
  }

  setLeadTimeFromStatus();
});


})();
